import React from 'react';
import PropTypes from 'prop-types';
import {
    Col,
    Descriptions,
    Row,
} from 'antd';
import _ from 'lodash';
import {PageLoading} from "@/component";
import {format, FORMAT_LONG_ALL} from "@/util/dateUtils";
import {useTaskResultInfo} from "@/page/admin/JobsPage/jobService";

export default function TaskResultInfo({
    id
}) {

    const {loading, value} = useTaskResultInfo(id);
    const result = _.get(value, 'data', {});

    if (loading) {
        return <PageLoading />;
    }

    return (
            <Row>
                <Col span={24}>
                    <Descriptions column={1}>
                        <Descriptions.Item label="任务名称">{result.taskName}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions column={1}>
                        <Descriptions.Item label="执行时间">{format(result.execTime, FORMAT_LONG_ALL)}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions column={1}>
                        <Descriptions.Item label="执行结果">{result.taskResult || '-'}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions column={1}>
                        <Descriptions.Item label="IP 地址">{result.ip}</Descriptions.Item>
                    </Descriptions>

                </Col>
            </Row>
    );
}

TaskResultInfo.propTypes = {
    id: PropTypes.string,
};
